'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _utils = require('utils');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

var _subscriptions = require('redux/modules/subscriptions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Upgrade = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    plans: state.subscriptions.plans,
    upgrades: state.subscriptions.upgrades
  };
}, { getUpgrade: _subscriptions.getUpgrade }, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Upgrade, _React$Component);

  function Upgrade(props) {
    (0, _classCallCheck3.default)(this, Upgrade);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Upgrade.__proto__ || (0, _getPrototypeOf2.default)(Upgrade)).call(this, props));

    _this.state = {
      screen: 'details'
    };
    return _this;
  }

  (0, _createClass3.default)(Upgrade, [{
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          getUpgrade = _props.getUpgrade,
          from = _props.subscription.planId,
          to = _props.to;


      getUpgrade(from, to);
    }
  }, {
    key: 'onViewListClicked',
    value: function onViewListClicked() {
      this.setState({
        screen: 'list'
      });
    }
  }, {
    key: 'onViewDetailsClicked',
    value: function onViewDetailsClicked() {
      this.setState({
        screen: 'details'
      });
    }
  }, {
    key: 'renderUpgradeDetails',
    value: function renderUpgradeDetails() {
      var styles = require('./UpgradeDialog.scss');
      var _props2 = this.props,
          fromId = _props2.subscription.planId,
          toId = _props2.to,
          plans = _props2.plans,
          upgrades = _props2.upgrades;


      var from = plans.find(function (p) {
        return p.type == fromId;
      });
      var to = plans.find(function (p) {
        return p.type == toId;
      });

      var prices = upgrades.prices;
      var oneOffCharge = prices.oneOffCharge,
          planCharge = prices.plan;
      var expiresAt = this.props.subscription.expiresAt;
      var upgradeCost = oneOffCharge.priceExcludingTax;
      var newRecurringCost = planCharge.priceExcludingTax;

      var nextBillingDate = (0, _moment2.default)(expiresAt).format('MMMM DD, YYYY');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.Upgrade__packages },
          _react2.default.createElement(
            'div',
            { className: styles.Upgrade__package + ' ' + styles['Upgrade__package--from'] },
            _react2.default.createElement(
              'div',
              { className: styles.Upgrade__packageTitleWrap },
              _react2.default.createElement(
                'h1',
                { className: styles.Upgrade__packageTitle },
                from.name
              ),
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageSubtitle },
                'Your Subscription'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.Upgrade__packageFeature },
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureValue },
                from.points
              ),
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureName },
                'Points / Month'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.Upgrade__packageFeature },
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureValue },
                from.accessResolutionName
              ),
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureName },
                'Resolution'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.Upgrade__package + ' ' + styles['Upgrade__package--to'] },
            _react2.default.createElement(
              'div',
              { className: styles.Upgrade__packageTitleWrap },
              _react2.default.createElement(
                'h1',
                { className: styles.Upgrade__packageTitle },
                to.name
              ),
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageSubtitle },
                'New Subscription'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.Upgrade__packageFeature },
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureValue },
                to.points
              ),
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureName },
                'Points / Month'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.Upgrade__packageFeature },
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureValue },
                to.accessResolutionName
              ),
              _react2.default.createElement(
                'span',
                { className: styles.Upgrade__packageFeatureName },
                'Resolution'
              )
            )
          )
        ),
        _react2.default.createElement(
          'table',
          { className: styles.Upgrade__costs },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              { className: styles.Upgrade__costsTitle },
              _react2.default.createElement(
                'td',
                { colSpan: '2' },
                'This Month'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Upgraded assets'
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_components.Button, { small: true, className: styles.Upgrade__viewListButton, label: 'View list', onClick: this.onViewListClicked.bind(this) })
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Extra points'
              ),
              _react2.default.createElement(
                'td',
                null,
                to.points - from.points
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Upgrade cost'
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _utils.prettyDollars)(upgradeCost),
                ' (one-time)'
              )
            ),
            _react2.default.createElement(
              'tr',
              { className: styles.Upgrade__costsTitle },
              _react2.default.createElement(
                'td',
                { colSpan: '2' },
                'Next Month'
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Points'
              ),
              _react2.default.createElement(
                'td',
                null,
                to.points
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Recurring cost'
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _utils.prettyDollars)(newRecurringCost)
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Next billing date'
              ),
              _react2.default.createElement(
                'td',
                null,
                nextBillingDate
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.Upgrade__cta },
          _react2.default.createElement(_components.Button, {
            primary: true,
            link: true,
            to: '/upgrade/' + to.type,
            label: 'Proceed to Payment',
            onClick: this.props.onCloseNo })
        )
      );
    }
  }, {
    key: 'renderUpgradedAssets',
    value: function renderUpgradedAssets() {
      var styles = require('./UpgradeDialog.scss');
      var _props3 = this.props,
          fromId = _props3.subscription.planId,
          toId = _props3.to,
          plans = _props3.plans,
          upgrades = _props3.upgrades;


      var from = plans.find(function (p) {
        return p.type == fromId;
      });
      var to = plans.find(function (p) {
        return p.type == toId;
      });

      var prices = upgrades.prices,
          upgradedAssets = upgrades.acls;
      var oneOffCharge = prices.oneOffCharge,
          planCharge = prices.plan;
      var expiresAt = this.props.subscription.expiresAt;
      var upgradeCost = oneOffCharge.priceExcludingTax;
      var newRecurringCost = planCharge.priceExcludingTax;

      var nextBillingDate = (0, _moment2.default)(expiresAt).format('MMMM DD, YYYY');

      return _react2.default.createElement(
        'div',
        { className: styles.UpgradedAssets },
        _react2.default.createElement(_components.Button, { small: true, className: styles.Upgrade__viewDetailsButton, label: 'Back', onClick: this.onViewDetailsClicked.bind(this) }),
        _react2.default.createElement(
          'p',
          { className: styles.UpgradedAssets__title },
          'The following assets were acquired this month as part of your subscription. They will be upgraded for free:'
        ),
        _react2.default.createElement(
          'table',
          { className: styles.UpgradedAssets__list },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                'Asset ID'
              ),
              _react2.default.createElement(
                'td',
                null,
                'Current Resolution'
              ),
              _react2.default.createElement(
                'td',
                null,
                'Maximum Resolution Available'
              ),
              _react2.default.createElement(
                'td',
                null,
                'Upgraded Resolution'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            upgradedAssets.map(function (_ref) {
              var assetID = _ref.assetID,
                  resolution = _ref.resolution,
                  maxResolution = _ref.maxResolution;
              return _react2.default.createElement(
                'tr',
                { className: styles.UpgradedAssets__item },
                _react2.default.createElement(
                  'td',
                  { className: styles.UpgradedAssets__itemName },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/assets/' + assetID, target: '_blank' },
                    assetID
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.UpgradedAssets__itemCurrentRes },
                  resolution
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.UpgradedAssets__itemMax },
                  maxResolution
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.UpgradedAssets__itemUpgradeRes },
                  Math.min(maxResolution, to.accessResolution)
                )
              );
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./UpgradeDialog.scss');

      var screen = this.state.screen;
      var upgrades = this.props.upgrades;
      var loading = upgrades.loading;


      return _react2.default.createElement(
        _components.PopupBox,
        { className: styles.Popup },
        loading ? _react2.default.createElement(_components.LoadingIndicator, { className: styles.LoadingIndicator }) : _react2.default.createElement(
          'div',
          { className: styles.Upgrade },
          _react2.default.createElement(
            'div',
            { className: styles.Upgrade__title },
            _react2.default.createElement(
              'h1',
              null,
              'Upgrade your subscription'
            )
          ),
          screen == 'details' && this.renderUpgradeDetails(),
          screen == 'list' && this.renderUpgradedAssets()
        )
      );
    }
  }]);
  return Upgrade;
}(_react2.default.Component)) || _class);
exports.default = Upgrade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpgradeDialog/UpgradeDialog.jsx
// module id = 2753
// module chunks = 0